import { render, staticRenderFns } from "./publicBug.vue?vue&type=template&id=6ccdd08e&scoped=true&"
import script from "./publicBug.vue?vue&type=script&lang=js&"
export * from "./publicBug.vue?vue&type=script&lang=js&"
import style0 from "./publicBug.vue?vue&type=style&index=0&id=6ccdd08e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccdd08e",
  null
  
)

export default component.exports